/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from 'react';

import { Skeleton } from '@mui/material';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { useAuth } from 'utils/contexts/auth-context';
import { useNavigate } from 'react-router-dom';
import { useMeetingStatus } from 'utils/contexts/meeting-status-context';
import CardAlertContainer from 'shared/components/alert-card/alert-card.component';
import LoadingButton from 'shared/components/button/loading-button.component';
import LanguageSelector from 'shared/components/language-selector/card-selector.component';
import useRequestInterpreter from './hooks/request.service';
import Page from 'components/page/page.component';
import { STRINGS, UserType } from 'utils/constants';
import { useFlags } from 'launchdarkly-react-client-sdk';
import Unavailable from 'components/Unavailable/Unavailable';

const JoinInterpreter: FC = () => {
  const {
    userZoomData,
    getUserZoomData,
    location,
    isLoggedIn,
    sorensonUser,
    loading,
  } = useAuth();
  const { submit, loading: requestLoading } = useRequestInterpreter();
  const {
    isInterpreterConnected,
    isInMeeting,
    isHost,
    currentMeeting,
    interpreterRequest,
    initialLoad,
  } = useMeetingStatus();
  const navigate = useNavigate();

  const [language, setLanguage] = useState<string>();

  const { language_selector, vri_language_selector, zoom_killswitch } =
    useFlags();

  const handleSumbit = () => {
    submit(language);
  };

  useEffect(() => {
    if (!userZoomData.accountId) {
      setTimeout(getUserZoomData, 0);
    }
  }, [getUserZoomData]);

  useEffect(() => {
    if (isInterpreterConnected) {
      navigate('/thankyou');
    }
  }, [isInterpreterConnected]);

  useEffect(() => {
    if (
      !loading &&
      !location &&
      location === null &&
      isLoggedIn &&
      !zoom_killswitch &&
      sorensonUser.userType === UserType.VRI
    ) {
      navigate('/location');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sorensonUser]);

  return (
    <>
      {!interpreterRequest.inProcess ? (
        <Page pageTitle='Get Interpreter'>
          {!zoom_killswitch ? (
            <>
              {!initialLoad && !userZoomData.canRequest && (
                <CardAlertContainer
                  severity='error'
                  mainText='Please first start or create a Zoom meeting to get an ASL
                    interpreter.'
                />
              )}
              {!isInMeeting &&
                !initialLoad &&
                !isHost &&
                userZoomData.canRequest && (
                  <CardAlertContainer severity='error'>
                    Please <b>first</b> start or create a Zoom meeting to get an
                    ASL interpreter.
                  </CardAlertContainer>
                )}
              {interpreterRequest.error && (
                <CardAlertContainer
                  severity='error'
                  mainText={
                    interpreterRequest.errorMessage ||
                    STRINGS.ERROR_STRINGS.UNABLE_TO_REQUEST
                  }
                />
              )}
              {((language_selector && sorensonUser.userType === UserType.VRS) ||
                (vri_language_selector &&
                  sorensonUser.userType === UserType.VRI)) && (
                <LanguageSelector
                  initialLoad={initialLoad}
                  disabled={!userZoomData.canRequest}
                  setLanguage={setLanguage}
                />
              )}

              {initialLoad ? (
                <Skeleton
                  variant='rectangular'
                  sx={{ borderRadius: '8px' }}
                  width='100%'
                  height={56}
                />
              ) : (
                <>
                  <LoadingButton
                    onClick={handleSumbit}
                    type='submit'
                    loading={requestLoading}
                    disabled={
                      !currentMeeting?.joinUrl ||
                      requestLoading ||
                      !userZoomData.canRequest
                    }
                  >
                    Get an ASL interpreter
                  </LoadingButton>
                </>
              )}
            </>
          ) : (
            <Unavailable />
          )}
        </Page>
      ) : (
        isInMeeting && <LoadingScreen />
      )}
    </>
  );
};
export default JoinInterpreter;
